"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeDriveLocalContentFactory = exports.ToolboxDriveLocalContentFactory = void 0;
var toolbox_1 = require("./toolbox");
var hashable_1 = require("../../../native/content/hashable");
var ToolboxDriveLocalContentFactory = /** @class */ (function () {
    function ToolboxDriveLocalContentFactory(toolbox) {
        this.toolbox = toolbox;
    }
    ToolboxDriveLocalContentFactory.prototype.create = function (content) {
        return new toolbox_1.LocalToolboxDriveContent(content, this.toolbox);
    };
    return ToolboxDriveLocalContentFactory;
}());
exports.ToolboxDriveLocalContentFactory = ToolboxDriveLocalContentFactory;
var NativeDriveLocalContentFactory = /** @class */ (function () {
    function NativeDriveLocalContentFactory() {
    }
    NativeDriveLocalContentFactory.prototype.create = function (content) {
        return new hashable_1.HashableNativeContent(content);
    };
    return NativeDriveLocalContentFactory;
}());
exports.NativeDriveLocalContentFactory = NativeDriveLocalContentFactory;
